import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "leaflet/dist/leaflet.css";
import { Analytics } from "@vercel/analytics/react"
import HomePage from "./pages/HomePage";
import OrderDecolonizingMission from "./pages/OrderDecolonizingMission";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />

        <Route
          path="/order-decolonizing-mission"
          element={<OrderDecolonizingMission />}
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </Router>
  );
}